import { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { ButtonLink, Card, Table } from 'components/UI'
import { destroy, init } from 'store/actions/tables'
import { closeModal } from 'store/actions/modals'
import BaseModal from 'components/Modals/BaseModal'
import { createErrorNotification } from 'store/actions/notifications'
import { getRequestTypeName } from 'services/Utilities'
import { generateDateText } from 'services/Requests'
import Api from 'services/Api'

import { t } from 'translations'

type OverlappingTimeoffsModalProps = {
  overlappingTimeOffs: string[]
}

const OverlappingTimeoffsModal: FC<OverlappingTimeoffsModalProps> = ({ overlappingTimeOffs }) => {
  const dispatch = useDispatch()
  const rowActions = [
    ({ _id }) => (
      <ButtonLink
        className="btn btn-outline-secondary"
        href={`/manage/timeoff/${_id}`}
        text={t('manager.punch.OVERLAPPINGTIMEOFFS.SEE')}
        onClick={() => dispatch(closeModal())}
      />
    )
  ]

  useEffect(() => {
    async function fetchOverlappingTimeoffs({ filter, page }) {
      const { count, vacations, success }: { count: number; vacations: MData.TimeOff[]; success: boolean } = await Api(`/requests/vacation`, {
        params: {
          ...filter,
          limit: 10,
          page,
          _ids: overlappingTimeOffs,
          sort: '-start'
        }
      })
      if (!success) return dispatch(createErrorNotification())
      return [vacations, count]
    }
    const header = [
      {
        key: '_id',
        label: 'manager.punch.OVERLAPPINGTIMEOFFS.INFORMATIONS',
        type: 'custom',
        notRemovable: true,
        render: (_, { start, end, vacationTypeId, requestStatusId }: MData.TimeOff) => (
          <>
            <div className="d-flex flex-row">
              <b>{t('manager.punch.OVERLAPPINGTIMEOFFS.DATE')}</b>
              <div className="ml-1">{generateDateText(start, end)}</div>
            </div>
            <div className="d-flex flex-row">
              <b>{t('manager.punch.OVERLAPPINGTIMEOFFS.TYPE')}</b>
              <div className="ml-1"> {getRequestTypeName(vacationTypeId)}</div>
            </div>
            <div>
              <b>{t('manager.punch.OVERLAPPINGTIMEOFFS.STATUS')}</b>
              {t(`manager.timeOffs.${requestStatusId}`)}
            </div>
          </>
        )
      }
    ]

    init('overlappingTimeOffs', header, fetchOverlappingTimeoffs, { defaultSortKey: '-start' })
    return () => destroy('overlappingTimeOffs')
  }, [dispatch, overlappingTimeOffs])

  return (
    <BaseModal title={`manager.punch.OVERLAPPINGTIMEOFFS`}>
      <Card>
        <Table name="overlappingTimeOffs" rowActions={rowActions} />
      </Card>
    </BaseModal>
  )
}

export default OverlappingTimeoffsModal
